import { useContext } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api, type IStaffPassUser, type IGetUserByStaffPass } from "@/logic/api";
import { SessionContext } from "@/utility/useSession";
import { useApiWithReject } from "@/utility/utils";

export const useGetUserByStaffPass = () => {
  const { current: session } = useContext(SessionContext);
  const queryClient = useQueryClient();
  const getUserApi = useApiWithReject(api.hooks.shift.getUserByStaffPass());

  const userUuid = session?.site?.user?.uuid;
  const tenantId = session?.site?.tenant?.id;

  return useMutation<IStaffPassUser, Error, IGetUserByStaffPass>({
    mutationFn: async (payload) => {
      if (!session?.context) {
        throw new Error("Session context not available");
      }
      return getUserApi.send(session.context, payload);
    },
    onSuccess: () => {
      // TODO: dd - double check edge cases and if not needed remove this
      queryClient.invalidateQueries({
        queryKey: ["shift", "data", userUuid, tenantId],
      });
    },
  });
};
